import { useAuth0 } from "@auth0/auth0-react"
import React, { useState } from "react"
import { Button, Icon } from "semantic-ui-react"
import BifrostButton from "../../../Components/BifrostElementComponent/BifrostButton/BifrostButton"
import BifrostModal from "../../../Components/BifrostPageComponent/BifrostModal/BifrostModal"
import Loader from "../../../Components/BifrostPageComponent/Loader/Loader"
import { validateInput } from "../../../Utils/Validator/ValidateInput"
import AddFeatureToOrgPage from "./AddFeatureToOrgPage"

const initialValidatedState = {
	feature_id: true
}

const initialValueState = {
	name: "",
	feature_id: null
}

const AddFeatureToOrgModal = ({ chosenOrg, refreshOrgDetails, orgDetailsLoading }) => {
	const { getAccessTokenSilently } = useAuth0()
	const [values, setValues] = useState(initialValueState)
	const [validated, setValidated] = useState(initialValidatedState)
	const [showErrorMessage, setShowErrorMessage] = useState(false)
	const [openModal, setOpenModal] = useState(false)

	const [isLoading, setIsLoading] = useState(false)

	const submitHandler = () => {
		validateInput(values, validated, setValidated) && postAddFeatureToOrg()
	}

	const postAddFeatureToOrg = async () => {
		setIsLoading(true)
		return fetch(
			new Request(process.env.REACT_APP_SESSION_ADDR + "/api/v2/org/" + chosenOrg.id + "/feature/" + values.feature_id, {
				method: "PUT",
				headers: new Headers({
					"authorization": "Bearer " + (await getAccessTokenSilently()),
					"Content-Type": "application/json"
				})
			})
		)
			.then((response) => {
				if (response.ok) {
					console.log("Posted AddFeatureToOrg successfully!")
					return response
				} else if (response.statusText === "Unauthorized") {
					throw new Error("Unauthorized")
				} else {
					console.log(response.statusText)
					throw new Error("Something went wrong")
				}
			})
			.then(() => {
				refreshOrgDetails(chosenOrg.id)
			})
			.then(() => {
				setOpenModal(false)
			})
			.catch(() => {
				setValidated({ ...initialValidatedState })
				setValues({ ...initialValueState })
				setShowErrorMessage(true)
			})
			.finally(() => {
				setIsLoading(false)
			})
	}

	const cancelHandler = () => {
		setValidated({ ...initialValidatedState })
		setValues({ ...initialValueState })
		setShowErrorMessage(false)
		setOpenModal(false)
	}

	return (
		<BifrostModal
			title={"Add Feature to " + chosenOrg.name}
			open={openModal}
			setOpen={setOpenModal}
			closeOnEscape={!isLoading}
			closeOnDimmerClick={!isLoading}
			trigger={
				<Button disabled={orgDetailsLoading} style={{ color: "white", backgroundColor: "rgb(77, 113, 152)", float: "right", marginBottom: "10px" }} size="mini" icon>
					<Icon name="plus" />
				</Button>
			}
			modalPage={
				isLoading ? (
					<Loader backgroundColor="white" inverted height="1px" minHeight="100px" />
				) : (
					<AddFeatureToOrgPage validated={validated} values={values} setValues={setValues} showErrorMessage={showErrorMessage} />
				)
			}
			modalActions={
				<>
					<BifrostButton style={{ display: "inline-block" }} onClick={() => submitHandler()} disabled={isLoading}>
						Submit
					</BifrostButton>
					<BifrostButton onClick={() => cancelHandler()} style={{ display: "inline-block" }} color="gray" disabled={isLoading}>
						Cancel
					</BifrostButton>
				</>
			}
		/>
	)
}

export default AddFeatureToOrgModal
